export default {
  de: {
    title: (firstname) => `Hallo ${firstname}!`,
    welcome: 'Willkommen im Kommunikationskoffer der SPÖ Burgenland!',
  },
};
